import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Logo from '../../../assets/icons/logo.svg?react';
import { ROUTES } from '../../../constants/routes';
import { LandingLanguageToggle } from './LandingLanguageToggle';

export const LandingHeader = () => {
  const { t } = useTranslation();

  return (
    <header className="lp-header">
      <div className="lp-shell lp-header__inner">
        <Link to={`/${ROUTES.LANDING}`} className="lp-header__logo" aria-label="Electric group">
          <Logo />
        </Link>

        <div className="lp-header__actions">
          <LandingLanguageToggle />
          <Link
            to={`/${ROUTES.ORGANISATION_LOGIN}`}
            className="lp-btn lp-btn--primary lp-btn--sm"
          >
            {t('landing.nav.enter')}
          </Link>
        </div>
      </div>
    </header>
  );
};

export default LandingHeader;
